import { render, staticRenderFns } from "./HostingStatistics.vue?vue&type=template&id=958ade5e&"
import script from "./HostingStatistics.vue?vue&type=script&lang=js&"
export * from "./HostingStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports